const PerksSection = () => {
  const perks = [
    {
      icon: "🧭", // Compass for "discovery"
      title: "Somehow Discovered Us",
    },
    {
      icon: "📝", // Form or document
      title: "Fill A Quick Form",
    },
    {
      icon: "🔐", // Locked data for privacy
      title: "Update Us About Your Property",
    },
    {
      icon: "🎬", // Clapperboard for filming/marketing
      title: "We List and Market your Property",
    },
    {
      icon: "📍", // Location pin for visits
      title: "We Arrange Site Visits",
    },
    {
      icon: "🎯", // Target hit to represent success
      title: "Property gets sold within 45 Days",
    },
  ];
  

  return (
    <div
      style={{
        padding: "  10px",
      }}
      className="flex justify-center items-center flex-col mb-100"
    >
      <h2
        style={{
          fontSize: 40,
          marginBottom: 30,
          fontFamily: "Playfair Display, sans-serif",
        }}
        className="text-center text-lg font-bold leading-none text-[#7C3A21]    "
      >
        How it Works
      </h2>
      <h2 className="text-center text-md w-full   leading-normal align-center mb-10 font-semibold   text-gray-900">
        Think of us as a premium broker who loves to sell within 45 days, and
        absolutely hates brokerage.
      </h2>
      <div className="max-w-7xl mx-auto grid grid-cols-2  md:grid-cols-3  lg:grid-cols-6 gap-6 justify-items-center">
        {perks.map((perk, index) => (
          <div
            key={index}
            className=" rounded-t-full rounded-b-xl bg-[#e6cbc2] shadow-md p-6 text-center   flex flex-col items-center"
          >
            <div className="text-5xl mb-4">{perk.icon}</div>
            <p className="text-sm font-medium text-gray-800">{perk.title}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PerksSection;
